// extracted by mini-css-extract-plugin
export var body = "_ec-8";
export var button = "_ec-0";
export var closeButton = "_ec-5";
export var content = "_ec-3";
export var empty = "_ec-f";
export var grid = "_ec-c";
export var header = "_ec-4";
export var icon = "_ec-1";
export var option = "_ec-d";
export var optionSelected = "_ec-e";
export var overlay = "_ec-2";
export var searchIcon = "_ec-a";
export var searchInput = "_ec-b";
export var searchWrapper = "_ec-9";
export var title = "_ec-6";
export var visuallyHidden = "_ec-7";